import React from 'react'
import { Rectangle } from 'recharts'

const Cell = ({ borderRadius, ...rest }) => (
  <Rectangle radius={[borderRadius, borderRadius, 0, 0]} {...rest} stroke={undefined} />
)

export default Cell
